import React, { FC } from 'react';
import { createRandomKey } from '../../../../utils/jsxUtils';
import { getPercentPieChartConfig } from '../../getPieChartConfig';
import { ChartPercentLegend } from '../../legend/ChartLegend';
import { LazyReactChart } from '../../LazyReactChart';
import {
  EntityChartBlock,
  EntityChartItem,
} from '../../components/EntityChartComponents';

type Props = {
  typologiesData: Array<number> | null;
  typologiesLabels: Array<string> | null;
};

export const CustomersTypologiesChart: FC<Props> = ({
  typologiesData,
  typologiesLabels,
}) => {
  const typologiesCanvasId = `typologies-chart${createRandomKey()}`;
  const typologiesBaseH = 158;

  return (
    <EntityChartBlock>
      <EntityChartItem>
        {typologiesData && typologiesLabels && (
          <LazyReactChart
            config={getPercentPieChartConfig({
              data: typologiesData,
              labels: typologiesLabels,
              canvasId: typologiesCanvasId,
              baseH: typologiesBaseH,
            })}
          />
        )}
      </EntityChartItem>
      {typologiesData && typologiesLabels && (
        <ChartPercentLegend
          data={typologiesData}
          labels={typologiesLabels}
          baseH={typologiesBaseH}
        />
      )}
    </EntityChartBlock>
  );
};
